<template>
  <div class="paper-analysis-result">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <div class="result-info">
      <span>任务名称：{{ taskName }}</span>
      <span style="margin-left: 24px;">考试批次：{{ planNames }}</span>
      <span style="margin-left: 24px;">分析科目数：{{ courseCount }}</span>
    </div>

    <div v-loading="loading">
      <div v-for="item in resultList" :key="item.id" class="course-section">
        <div class="course-header">
          <span class="course-title">{{ item.courseName }}</span>
          <span class="course-batch">批次：{{ item.planNames }}</span>
          <el-tag size="small" :type="String(item.paperForm) === '1' ? '' : 'warning'">
            《{{ item.paperName }}》- {{ String(item.paperForm) === '1' ? '固定卷' : '随机卷' }}
          </el-tag>
          <el-button type="text" style="margin-left: 16px;" @click="goDetail(item)">查看详情</el-button>
        </div>
        <TaskResultCards :data="item" />
      </div>

      <el-empty v-if="!loading && resultList.length === 0" description="暂无分析结果" />
    </div>
  </div>
</template>

<script>
import { getTaskResultAPI } from '@/http/modules/examSet/paperAnalysis'
import TaskResultCards from './components/TaskResultCards'

export default {
  name: 'PaperAnalysisResult',
  components: { TaskResultCards },
  data() {
    return {
      loading: false,
      mainTopBtnList: [
        { title: '返回', type: 'info', plain: true, fn: this.goBack }
      ],
      taskName: '',
      planNames: '',
      courseCount: 0,
      resultList: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const taskId = this.$route.query.taskId
      if (!taskId) return
      this.loading = true
      try {
        const res = await getTaskResultAPI({ taskId })
        if (res.code === 1 && res.data) {
          this.taskName = res.data.taskName || ''
          this.planNames = res.data.planNames || ''
          this.courseCount = res.data.courseCount || 0
          this.resultList = res.data.resultList || []
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.push({ name: 'paperAnalysis' })
    },
    goDetail(item) {
      this.$router.push({ name: 'paperAnalysisDetail', query: { resultId: item.id,paperForm: item.paperForm, taskId: this.$route.query.taskId } })
    }
  }
}
</script>

<style lang="less" scoped>
.paper-analysis-result { padding:0px 20px; }
.result-info { margin-bottom: 20px; color: #606266; font-size: 14px; }
.course-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  .course-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .course-title { font-size: 16px; font-weight: bold; margin-right: 12px; }
    .course-batch { color: #909399; font-size: 13px; margin-right: 12px; }
  }
}
</style>
